import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import RequestRepair from "./pages/RequestRepair";
import Track from "./pages/Track";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import Flyer from "./pages/Flyer";
import BusinessCards from "./pages/BusinessCards";
import GamingPC from "./pages/GamingPC";
import { AuthProvider, Protected } from "./context/AuthContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/request" element={<RequestRepair />} />
            <Route path="/track" element={<Track />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/gaming-pc" element={<GamingPC />} />
            <Route path="/flyer" element={<Flyer />} />
            <Route path="/cards" element={<BusinessCards />} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0F172A", border: "1px solid rgba(255,255,255,0.1)", color: "#F8FAFC", borderRadius: 2 } }} />
    </div>
  );
}

export default App;
